module.exports = __webpack_public_path__ + "media/images/abonne_airtel-8e008355a958bc7c75a404f4ea00ed3b.svg";